import React, { useMemo, useState, useRef, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import moment from 'moment';

import { number } from '~/helpers';

import { UnidataTable } from '~/components';
import { FormatarCodigoLiberacao } from '~/helpers';
import {
  operacaoLiberacaoRemotaInRequest,
  recordFiltering,
} from '~/store/modules/operacaoliberacaoremota/actions';

import { Heading, Form } from './components';

function OperacaoLiberacaoRemotaList() {
  const data = useSelector((state) => state.operacaoliberacaoremota);
  const dispatch = useDispatch();

  const formRef = useRef(null);

  const [modal, setModal] = useState(false);
  const [params, setParams] = useState({});
  
  const header = useMemo(() => [
    {
      id: 'veic_placa_apresentacao',
      label: 'Placa',
      filter: { type: 'text' },
      align: 'left'
    },
    {
      id: 'lire_codigo1',
      label: 'Codigo 1',
      formatted: (value) => FormatarCodigoLiberacao(value),
      align: 'left'
    },
    {
      id: 'lire_codigo2',
      label: 'Codigo 2',
      formatted: (value) => FormatarCodigoLiberacao(value),
      align: 'left'
    },
    { id: 'bico_numero', label: 'Cód. Bico', align: 'left' },
    { id: 'bico_descricao', label: 'Bico', align: 'left' },
    { id: 'poco_codigo', label: 'Cód. Posto', align: 'left' },
    { id: 'poco_descricao', label: 'Posto', align: 'left' },
    { id: 'cond_cpf', label: 'Cód.Condutor', align: 'left' },
    { id: 'cond_nome', label: 'Condutor', align: 'left' },
    { id: 'usua_login', label: 'Login', align: 'left' },
    { id: 'usua_nome', label: 'Usuário', align: 'left' },
    {
      id: 'lire_data',
      label: 'Data Liberação',
      formatted: (value) => moment(value).format('DD/MM/YYYY HH:mm'),
      align: 'left',
    },
    { id: 'veic_totalizador',
      label: 'Totalizador',
      align: 'right',
      formatted: (value) => number(value, 1),
    },
    { id: 'imab_codigo', label: 'Cód. Impedimento', align: 'right' },
    { id: 'lire_status', label: 'Status', align: 'right' },
  ], []);

  // Close Modal Edit
  const handleCloseModalEdit = useCallback(() => {
    setModal(false);
    setParams({});
    dispatch(recordFiltering(data.params));
  }, [data]);

  useEffect(() => {
    if (modal) formRef.current.openModal();
  }, [modal]);

  return (
    <>
      <UnidataTable
        fixed
        header={header}
        redux={data}
        read={operacaoLiberacaoRemotaInRequest}
        keys={['lire_codigo1', 'lire_codigo2', 'poco_codigo']}
        create={false}
        update={false}
        toolbar={Heading}
        detach="veic_placa_apresentacao"
      />

      {modal && (
        <Form
          ref={formRef}
          onCloseModal={handleCloseModalEdit}
          formEdit={params}
        />
      )}

    </>
  );
}

export default OperacaoLiberacaoRemotaList;
